import type { Helpers } from './internal.js';

export function createUploadsResource({ requestMultipart }: Helpers) {
  return {
    // Upload genérico de imagem → { url } (URL pública no MinIO via Caddy /storage).
    // O filename no 3º arg é obrigatório: @fastify/multipart só reconhece a parte
    // como arquivo se houver filename no Content-Disposition. FormData.append sem
    // ele (caso de Blob puro) faz o backend tratar como campo → missing_file (422).
    async image(file: Blob | File): Promise<{ url: string }> {
      const form = new FormData();
      const filename = file instanceof File ? file.name : 'upload';
      form.append('file', file, filename);
      return (await requestMultipart('/api/uploads/image', form)) as { url: string };
    },
  };
}
